// src/pages/print.jsx
import React, { useEffect, useState } from "react";
import { supabase } from "../utils/supabaseClient";
import PublicFlyerA4 from "../components/flyer/PublicFlyerA4";

export default function PrintPage() {
  const params = new URLSearchParams(window.location.search);
  const sector = params.get("sector")?.toUpperCase() || "PR4";

  const [slots, setSlots] = useState([]);
  const [flyerLoaded, setFlyerLoaded] = useState(false);

  useEffect(() => {
    async function load() {
      const { data: flyerData } = await supabase
        .from("flyers")
        .select("*")
        .eq("postcode_sector", sector)
        .order("created_at", { ascending: false })
        .limit(1);

      const flyer = flyerData?.[0];
      if (!flyer) {
        setFlyerLoaded(true);
        return setSlots([]);
      }

      const { data: slotData } = await supabase
        .from("flyer_slots")
        .select("*")
        .eq("flyer_id", flyer.id)
        .eq("postcode_sector", sector)
        .order("slot_number", { ascending: true });

      setSlots(slotData || []);
      setFlyerLoaded(true);
    }

    load();
  }, [sector]);

  if (!flyerLoaded) {
    // ⭐ IMPORTANT: no wrapper, no height, no opacity
    return null;
  }

  return <PublicFlyerA4 sector={sector} slots={slots} />;
}
